<template>

  <div class="uk-card uk-card-default uk-card-primary uk-card-hover">

    <div class="uk-card-header">
      <div class="uk-card-title">Compliance</div>
      <h6>Showing Data from {{startDate}} onward.</h6>
    </div>

    <div class="uk-card-body">
      <div class="card-stretch-container">
        <div class="bignumber secondary">
          <div class='number'>
            {{complianceRate}}%
          </div>
          <div class='label'>
            Match Rate
          </div>
        </div>
        <div class="bignumber">
          <div class='number'>
            {{ formatNumberWithCommas(driverCompliedCount) }}
          </div>
          <div class='label'>
            ID Checks Entered
          </div>
        </div>
        <div class="bignumber">
          <div class='number'>
            {{ formatNumberWithCommas(volume) }}
          </div>
          <div class='label'>
            Calls Ran
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>


  import {formatNumberWithCommas} from "@/utils/format";

  export default {
		name: "ComplianceCard",
    props: ["volume", "driverCompliedCount", "startDate"],
		computed: {
			complianceRate: function () {
				if (this.volume == 0) return 0;
				return Math.round((this.driverCompliedCount / this.volume) * 100)
			}
		},
    methods: {
			formatNumberWithCommas(int) {
				return formatNumberWithCommas(int)
      }
    }
	}
</script>

<style lang="less" scoped>


  @import "../../assets/less/palette.less";
  @import "../../assets/less/theme.less";


  .card-stretch-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }


  h6 {
    margin-top: 5px;
  }

  .bignumber {

    color: white!important;

    .number {
      font-size: 60px;
    }

    .label {
      font-size: 12px;
    }
  }


  @media only screen and (max-width: @breakpoint-medium) {
      .card-stretch-container {
        flex-direction: column;
        justify-content: center;

        .bignumber {
           margin: 10px 0;
        }
      }
  }

</style>
